import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function SideMenu({ isSidebarOpen, toggleSidebar }) {
    const [openMenu, setOpenMenu] = useState(null);

    const toggleMenu = (menu) => {
        setOpenMenu(openMenu === menu ? null : menu);
    };

    return (
        <div>
            <div id="side-bar" className={`side-bar ${isSidebarOpen ? 'show' : ''}`}>
                
                {/* BOTÃO FECHAR */}
                <button className="close-icon-menu" aria-label="Close Menu" onClick={toggleSidebar}>
                    <i className="far fa-times"></i>
                </button>

                <div className="rts-sidebar-menu-desktop">
                    {/* LOGO */}
                    <Link className="logo-1" to="/" onClick={toggleSidebar}>
                        <img className="logo" src="/assets/images/logo/logo-4.svg" alt="GB Partner Logo" />
                    </Link>

                    {/* TEXTO LATERAL (DESKTOP) */}
                    <div className="body d-none d-xl-block">
                        <p className="disc">
                            A <strong>GB Partner</strong> oferece soluções financeiras estruturadas para empresas, agronegócio e sustentabilidade, conectando você às melhores oportunidades do mercado global.
                        </p>

                        <div className="get-in-touch">
                            <div className="h6 title">Fale Conosco</div>
                            <div className="wrapper">
                                <div className="single">
                                    <i className="fas fa-phone-alt" />
                                    <Link to="https://wa.me/5571991810262" target="_blank">(85) 99999-9999</Link>
                                </div>
                                <div className="single">
                                    <i className="fas fa-envelope" />
                                    <Link to="mailto:contato@gbpartner.com.br">contato@gbpartner.com.br</Link>
                                </div>
                            </div>

                            <div className="social-wrapper-two menu">
                                <Link to="#"><i className="fab fa-facebook-f" /></Link>
                                <Link to="#"><i className="fab fa-instagram" /></Link>
                                <Link to="#"><i className="fab fa-linkedin-in" /></Link>
                                <Link to="#"><i className="fab fa-whatsapp" /></Link>
                            </div>
                        </div>
                    </div>

                    {/* MENU MOBILE (DROPDOWN) */}
                    <div className="body-mobile d-block d-xl-none">
                        <nav className="nav-main mainmenu-nav">
                            <ul className="mainmenu metismenu" id="mobile-menu-active">

                                <li><Link className="menu-link" to="/" onClick={toggleSidebar}>Início</Link></li>
                                <li><Link className="menu-link" to="/sobre-nos" onClick={toggleSidebar}>Sobre Nós</Link></li>

                                {/* SUBMENU SERVIÇOS ALINHADO */}
                                <li className="has-droupdown menu-item">
                                    <Link className="menu-link" to="#" onClick={() => toggleMenu(2)}>Serviços</Link>
                                    <ul className={`submenu ${openMenu === 2 ? 'mm-collapse mm-show' : 'mm-collapse'}`}>
                                        <li><Link to="/servicos" onClick={toggleSidebar}>Todos os Serviços</Link></li>
                                        <li><Link to="/servicos/credito-empresarial" onClick={toggleSidebar}>Crédito Empresarial</Link></li>
                                        <li><Link to="/servicos/agro" onClick={toggleSidebar}>Agro</Link></li>
                                        <li><Link to="/servicos/seguros" onClick={toggleSidebar}>Seguros</Link></li>
                                        <li><Link to="/servicos/credito-carbono" onClick={toggleSidebar}>Crédito de Carbono</Link></li>
                                        <li><Link to="/servicos/inteligencia-mercado" onClick={toggleSidebar}>Inteligência de Mercado</Link></li>
                                    </ul>
                                </li>

                                <li><Link className="menu-link" to="/portfolio" onClick={toggleSidebar}>Portfólio</Link></li>
                                <li><Link className="menu-link" to="/faq" onClick={toggleSidebar}>FAQ</Link></li>
                                <li><Link className="menu-link" to="/contato" onClick={toggleSidebar}>Contato</Link></li>
                            </ul>
                        </nav>

                        <div className="social-wrapper-two menu mobile-menu">
                            <Link to="#"><i className="fab fa-facebook-f" /></Link>
                            <Link to="#"><i className="fab fa-instagram" /></Link>
                            <Link to="#"><i className="fab fa-linkedin-in" /></Link>
                            <Link to="#"><i className="fab fa-whatsapp" /></Link>
                        </div>

                        <Link to="/contato" className="rts-btn btn-primary ml--20 header-one-btn" onClick={toggleSidebar}>
                            Fale Conosco
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SideMenu;